import { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import Icon from "components/ShellV2/Icon";

/* Right-side slide-over drawer (port of the design's Drawer): header with
   title/subtitle + close, scrollable body and a footer action bar. */
export default function Drawer({ open, title, sub, width, onClose, footer, children }) {
  const { t } = useTranslation(["common"]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="rec-drawer-scrim" role="presentation" onClick={onClose} />
      <div className="rec-drawer" style={{ width }} role="dialog" aria-modal="true">
        <div className="rec-drawer-head">
          <div className="flex-1 min-w-0">
            {title && <h3>{title}</h3>}
            {sub && <p>{sub}</p>}
          </div>
          <button type="button" className="rec-icon-btn" onClick={onClose} title={t("close")}>
            <Icon name="close" />
          </button>
        </div>
        <div className="rec-drawer-body">{children}</div>
        {footer && <div className="rec-drawer-foot">{footer}</div>}
      </div>
    </>
  );
}

Drawer.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.node,
  sub: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClose: PropTypes.func,
  footer: PropTypes.node,
  children: PropTypes.node,
};

Drawer.defaultProps = {
  open: false,
  title: null,
  sub: null,
  width: 520,
  onClose: undefined,
  footer: null,
  children: null,
};
